import {Popup, Position, ToolbarItem} from 'devextreme-react/popup';
import React, {useEffect, useRef, useState} from "react";
import {useEEToolContext} from "../contexts/eeToolContext";
import DataGrid, {Column, Editing, Format, Paging, Scrolling, Selection} from "devextreme-react/data-grid";
import {LoadPopupPanel} from "../../../../components";
import {useCompareMaterialOptions} from "../api/compare-material-options";
import {MaterialOption} from "../types/MaterialOption";
import {useEEToolAdapterContext} from "../contexts/eeToolAdapterContext";
import {useEstimateProducts} from "../api/estimate-products";
import {formatNumber} from "devextreme/localization";

export function EstimatePopupControl() {
    const adapterContext = useEEToolAdapterContext();
    const context = useEEToolContext();
    const estimateProducts = useEstimateProducts(context.dealerId, context.itemizedCharges, context.optionalProducts, context.customerZip, context.retailPriceBucketID, false)
    const [total, setTotal] = useState(0);

    useEffect(() => {
        if (estimateProducts.data) {
            setTotal(estimateProducts.data.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.extendedPrice;
            }, 0));
            
            // Capture retail price bucket ID from first product if available
            const bucketId = estimateProducts.data.find(p => p.retailPriceBucketId)?.retailPriceBucketId;
            if (bucketId && bucketId !== context.retailPriceBucketID) {
                context.setRetailPriceBucketID(bucketId);
            }
        }
    }, [estimateProducts.data]);

    if (!adapterContext.isEstimate)
        return <></>;

    return (
        <Popup
            visible={adapterContext.isEstimate}
            showTitle={true}
            width={500}
            height={500}
            shading={false}
            showCloseButton={true}
            onHidden={() => {
                adapterContext.setIsEstimate(false);
            }}
            position={'right top'}
        >
            <DataGrid
                className="product-search-results"
                dataSource={estimateProducts.data}
                allowColumnResizing={true}
                wordWrapEnabled={true}
                keyExpr={['productID']}
                repaintChangesOnly={true}
            >
                <Paging enabled={false}></Paging>
                <Scrolling rowRenderingMode='virtual'></Scrolling>
                <Column
                    dataField={'productType'}
                    caption={'Product Type'}
                    dataType="string"
                    width={120}
                    allowEditing={false}
                />
                <Column
                    dataField={'description'}
                    caption={'Item Description'}
                    dataType="string"
                    allowEditing={false}
                />
                <Column
                    dataField={'qty'}
                    caption={'Qty'}
                    dataType="number"
                    allowEditing={false}
                    width={60}
                />
                <Column
                    dataField={'extendedPrice'}
                    caption={'Extended Price'}
                    dataType="number"
                    allowEditing={false}
                    width={120}
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
            </DataGrid>
            <LoadPopupPanel visible={estimateProducts.isLoading}></LoadPopupPanel>
            <div className='dx-clearfix'>
                <table className='summary-table'>
                    <tbody>
                    <tr className='total'>
                        <td>Total:</td>
                        <td>{formatNumber(total, {type: 'currency', precision: 2})}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </Popup>
    );
}
